import { Box } from '@mui/material';

import PreVideoCallLayout from './preVideoCall';
import VideoCallLayout from './videoCall';
import VideoCallEndLayout from './videoCallEnd';

import {
  MeetingPage,
  useMeetingContext,
} from '../../../contexts/meeting/meetingContext';
import LoadingComponent from '../../common/loadingComponent';
import MeetingStatusChecker from '../../meeting/statusChecker';

function MeetingCallPageLayout() {
  const { meetingPage } = useMeetingContext();

  return (
    <Box
      sx={{
        height: '100vh',
        background: '#181818',
      }}
    >
      <MeetingStatusChecker />
      {!meetingPage && <LoadingComponent />}
      {meetingPage === MeetingPage.PRE_VIDEO_CALL && <PreVideoCallLayout />}
      {meetingPage === MeetingPage.VIDEO_CALL && <VideoCallLayout />}
      {meetingPage === MeetingPage.VIDEO_CALL_END && <VideoCallEndLayout />}
    </Box>
  );
}

export default MeetingCallPageLayout;
